// ── Vehicle reference data (ported from mobile — Session 10) ──

export const VEHICLE_MAKES = [
  'Acura', 'Audi', 'BMW', 'Buick', 'Cadillac', 'Chevrolet', 'Chrysler', 'Dodge',
  'Ford', 'GMC', 'Honda', 'Hyundai', 'Infiniti', 'Jeep', 'Kia', 'Lexus',
  'Lincoln', 'Mazda', 'Mercedes-Benz', 'Mitsubishi', 'Nissan', 'Ram',
  'Subaru', 'Tesla', 'Toyota', 'Volkswagen', 'Volvo', 'Other',
];

export const VEHICLE_COLORS = [
  'White', 'Black', 'Silver', 'Grey', 'Red', 'Blue',
  'Green', 'Brown', 'Beige', 'Orange', 'Yellow', 'Other',
];

export function getVehicleYears(): string[] {
  const current = new Date().getFullYear();
  const years: string[] = [];
  for (let y = current + 1; y >= 2000; y--) years.push(String(y));
  return years;
}

export const MODEL_PLACEHOLDERS: Record<string, string> = {
  Ford: 'F-150, Transit, Ranger...',
  Chevrolet: 'Silverado, Express, Colorado...',
  GMC: 'Sierra, Savana, Canyon...',
  Toyota: 'Tacoma, Tundra, RAV4...',
  Ram: '1500, 2500, ProMaster...',
  Honda: 'Civic, CR-V, Ridgeline...',
  Dodge: 'Grand Caravan, Durango...',
  Nissan: 'Frontier, NV, Titan...',
  Hyundai: 'Tucson, Santa Fe...',
  'Mercedes-Benz': 'Sprinter, Metris...',
};

export const VEHICLE_TYPES = [
  { value: 'truck', label: 'Truck' },
  { value: 'van', label: 'Van' },
  { value: 'suv', label: 'SUV' },
  { value: 'sedan', label: 'Sedan' },
  { value: 'trailer', label: 'Trailer' },
  { value: 'equipment', label: 'Equipment' },
  { value: 'other', label: 'Other' },
];
